module.exports = __webpack_public_path__ + "images/9005bfd667d7008a96e89797f2193e5c-produktkatalog.jpg";